import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import GenericModal from "src/GenericModal";
import FullScreenMobileView from "./fullScreenMobile";
import redScooter from "../../assets/scooter/Red.png";
import exchangeIcon from "../../assets/images/swap.svg";
import "./exchange.scss";
import BackArrow from "src/atoms/backArrow/backArrow";
import Cross from "../../assets/loanFlow/backCross.svg";
import { Link } from "react-router-dom";
import { makeAPICall } from "src/services/apiService";

const UploadScooter = () => {
  const history = useHistory();
  // let values = new URLSearchParams(window.location.search);
  const [regImages, setRegImages] = useState([]);
  const [scooterImages, setScooterImages] = useState([]);

  const [openCamera, setOpenCamera] = useState(false);
  const [reg, setReg] = useState(false);
  const [replaceIndex, setReplaceIndex] = useState(null);
  const [verifyPopup, setVerifyPopup] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [uploadErrorPopup, setUploadErrorPopup] = useState(false)

  useEffect(() => {
    if(openCamera) {
      document.getElementsByClassName("App")[0].style.overflow = 'hidden'
    } else {
      document.getElementsByClassName("App")[0].style.overflow = 'scroll'
    }
  }, [openCamera])

  const handleOpenCamera = (type, index) => {
    if (type === "scooter") {
      setReg(false);
    } else {
      setReg(true);
    }
    setReplaceIndex(index);
    setOpenCamera(true);
    setUploaded(false);
  };

  const handleImageData = (img) => {
    if (reg) {
      if (replaceIndex == null) {
        setRegImages([...regImages, img]);
      } else {
        let tmpArr = regImages;
        tmpArr[replaceIndex] = img;
        setRegImages(tmpArr);
      }
    } else {
      if (replaceIndex == null) {
        setScooterImages([...scooterImages, img]);
      } else {
        let tmpArr = scooterImages;
        tmpArr[replaceIndex] = img;
        setScooterImages(tmpArr);
      }
    }
    setReplaceIndex(null);
    setUploaded(false);
  };

  const verifyExchange = () => {
    if (regImages.length <= 0 && scooterImages.length < 2) {
      return;
    }
    let config = {
      method: "put",
      url: `api/exchange/verifyExchange`,
      params: {
        ...history.location.state,
      },
      data: {
        status: "VERIFIED",
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
          setVerifyPopup(false);
          localStorage.removeItem("currentExchange");
          history.replace("/booking-list");
        }
      })
      .catch((err) => {
        console.log("failed");
        setVerifyPopup(false);
      });
  };

  const UploadDocs = () => {
    if (regImages.length <= 0 || scooterImages.length <= 1) {
      return;
    }
    if (uploaded) {
      setVerifyPopup(true);
      return;
    }
    setOverlay(true);
    setUploadErrorPopup(false)
    let finalArr = [];
    regImages.map((a) =>
      finalArr.push({
        file: a,
        type: "SCOOTER_REGISTRATION",
        view: "FRONT",
        data: {},
        is_address_proof: false,
      })
    );
    scooterImages.map((a) =>
      finalArr.push({
        file: a,
        type: "VEHICLE_CONDITION",
        view: "FRONT",
        data: {},
        is_address_proof: false,
      })
    );
    let uploadBody = {
      address_proof: "",
      already_uploaded: false,
      order_id: history.location.state.order_id,
      files: [...finalArr],
    };
    let config = {
      method: "put",
      url: `api/exchange/uploadScooter`,
      params: {
        ...history.location.state,
      },
      data: { ...uploadBody },
    };

    makeAPICall(config)
      .then((resp) => {
        setOverlay(false);
        if (resp && resp.data?.status === "SUCCESS") {
          setVerifyPopup(true);
          setUploaded(true);
          // localStorage.removeItem("currentExchange");
          // history.replace("/booking-list");
        }
      })
      .catch((err) => {
        setOverlay(false);
        setUploadErrorPopup(true)
        console.log("failed");
      });
  };

  const handleDelete = (type, index) => {
    if (type === "registration") {
      setRegImages(regImages.filter((a, i) => i != index));
    } else {
      setScooterImages(scooterImages.filter((a, i) => i != index));
    }
    setUploaded(false);
  };

  const stopAll = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <>
      <div style={{ margin: "16px", paddingBottom: "124px", overflow: openCamera ? 'hidden' : 'scroll' }}>
        {overlay && (
          <div className="overlayed" onClick={(e) => stopAll(e)}></div>
        )}
        <div className="backArrow" style={{ marginLeft: "0px" }}>
          <Link to="/scooter-exchange-data">
            <BackArrow removeClass={true} />
          </Link>
        </div>
        <div>
          <p className="imageSecHeader">Registration Images</p>
          <p>* Min 1 picture required</p>
          {regImages.length > 0 ? (
            <div>
              <div
                id="RegImages"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  margin: "1%",
                  padding: "1%",
                }}
              >
                {regImages.map((item, index) => (
                  <div style={{ width: "calc(100%-32px)", margin: "1%" }}>
                    <img
                      key={index}
                      width={"100%"}
                      alt="NoImage"
                      src={item}
                      onClick={() => handleOpenCamera("registration", index)}
                    />
                    <div
                      onClick={() => handleDelete("registration", index)}
                      style={{
                        position: "relative",
                        left: "84%",
                        top: "-54px",
                        width: "48px",
                        height: "12px",
                      }}
                    >
                      <img src={Cross} alt="delete" />
                    </div>
                  </div>
                ))}
              </div>
              {regImages.length < 2 && (
                <div onClick={() => handleOpenCamera("registration")}>
                  Add another
                </div>
              )}
            </div>
          ) : (
            <div onClick={() => handleOpenCamera("registration")}>
              <img src={redScooter} width={"100%"} alt="Reg!" />
            </div>
          )}
        </div>
        <div>
          <p className="imageSecHeader">Scooter Images</p>
          <p>* Min 2 pictures required</p>
          <div>
            {scooterImages.length > 0 ? (
              <div>
                <div
                  id="ScooterImages"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "1%",
                    padding: "1%",
                  }}
                >
                  {scooterImages.map((item, index) => (
                    <div style={{ width: "calc(100%-32px)", margin: "1%" }}>
                      <img
                        key={index}
                        width={"100%"}
                        alt="NoImage"
                        src={item}
                        onClick={() => handleOpenCamera("scooter", index)}
                      />
                      <div
                        onClick={() => handleDelete("scooter", index)}
                        style={{
                          position: "relative",
                          left: "84%",
                          top: "-54px",
                          width: "48px",
                          height: "12px",
                        }}
                      >
                        <img src={Cross} alt="delete" />
                      </div>
                    </div>
                  ))}
                </div>
                {scooterImages.length < 5 && (
                  <div onClick={() => handleOpenCamera("scooter")}>
                    Add another
                  </div>
                )}
              </div>
            ) : (
              <div onClick={() => handleOpenCamera("scooter")}>
                <img src={redScooter} width={"100%"} alt="Scooter1" />
                <img src={redScooter} width={"100%"} alt="Scooter1" />
              </div>
            )}
          </div>
        </div>
        <button
          onClick={UploadDocs}
          className={`primary-btn`}
          style={{
            width: "calc(100% - 32px)",
            position: "fixed",
            bottom: "16px",
            left: "16px",
            background:
              regImages.length > 0 && scooterImages.length > 1
                ? "black"
                : "rgba(0, 0, 0, 0.6)",
            cursor:
              regImages.length > 0 && scooterImages.length > 1
                ? "pointer"
                : "no-drop",
          }}
        >
          Submit
        </button>
      </div>
      {openCamera && (
        <GenericModal showClose={false} fullScreen={true} onClose={() => setOpenCamera(false)}>
          <FullScreenMobileView
            onImageCapture={() => setOpenCamera(false)}
            handleImageDatas={handleImageData}
          />
        </GenericModal>
      )}
      {verifyPopup && (
        <GenericModal onClose={() => setVerifyPopup(false)} showClose={false}>
          <div className="popupHead">
            <div>Are you sure want to verify this exchange?</div>
            <img src={exchangeIcon} alt="exchangeIcon" />
          </div>

          <div className="popup-sub">
            Make sure you have checked all the properties mentioned
          </div>
          <div className="popup-btn">
            <button className="sec-btn" onClick={() => setVerifyPopup(false)}>
              Dismiss
            </button>
            <button onClick={() => verifyExchange()} className="primary-btn">
              Verify
            </button>
          </div>
        </GenericModal>
      )}
      {uploadErrorPopup && (
        <GenericModal onClose={() => setUploadErrorPopup(false)} showClose={false}>
          <div className="popupHead" style={{marginBottom: '0px'}}>
            <div>Document upload failed</div>
            <img src={exchangeIcon} alt="exchangeIcon" />
          </div>

          <div className="popup-sub">
          There was an error while uploading documents, please try again.
          </div>
          <div className="popup-btn">
            <button className="primary-btn" style={{width: '100%'}} onClick={() => setUploadErrorPopup(false)}>
              Dismiss
            </button>
          </div>
        </GenericModal>
      )}
    </>
  );
};

export default UploadScooter;
